<template>
  <div
    class="frisbuy-story-progress-bar"
    :class="{
      'frisbuy-story-progress-bar__hide_ig': isHideIg,
    }"
    @click.self.stop
  >
    <div
      v-for="(step, index) in postCount"
      class="frisbuy-story-progress-bar__step"
      :class="{
        'frisbuy-in-progress': index === currentPostIndex,
        'frisbuy-is-viewed': currentPostIndex > index,
      }"
      :key="step + index"
      @click="$emit('selectStep', index)"
    >
      <div
        class="frisbuy-step-progress"
        :class="{
          '--transition': isInProgress,
        }"
        :style="
          index == currentPostIndex && {
            marginLeft: `-${100 - currentSlideProgress}%`,
          }
        "
      ></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.frisbuy-story-progress-bar {
  display: flex;
  position: relative;
  width: 100%;
  z-index: 12;
}
.frisbuy-story-progress-bar__hide_ig {
  align-items: center;
}

.frisbuy-story-progress-bar__step {
  background-color: rgba(#fff, 0.4);
  height: 2px;
  border-radius: 2px;
  flex-grow: 1;
  flex-shrink: 0;
  cursor: pointer;
  box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  z-index: 2;

  &:not(:first-of-type) {
    margin-left: 4px;
  }

  &.frisbuy-in-progress {
    .frisbuy-step-progress {
      width: 100%;
      height: 100%;
      background-color: rgba(#fff, 0.8);
      margin-left: -100%;

      &.--transition {
        transition-property: margin-left;
        transition-duration: 1s;
        transition-timing-function: linear;
      }
    }
  }

  &.frisbuy-is-viewed {
    background-color: rgba(#fff, 0.8);
  }
}
</style>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  emits: ["selectStep"],

  props: {
    isHideIg: {
      type: Boolean,
      required: false,
      default: false,
    },

    postCount: {
      type: Number,
      required: true,
      validator: (prop: number) => prop > 0,
    },

    currentPostIndex: {
      type: Number,
      required: true,
      validator: (prop: number) => prop >= 0,
    },

    percentOfProgress: {
      type: Number,
      required: true,
      validator: (prop: number) => prop >= 0 && prop <= 100,
    },

    albumId: {
      type: Number,
      require: false,
    },
  },

  data() {
    return {
      isInProgress: false,
      currentSlideProgress: 0,
    };
  },

  methods: {
    resetProgressOfCurrentSlide() {
      this.isInProgress = false;
      this.currentSlideProgress = 0;
    },
  },

  watch: {
    currentPostIndex() {
      this.resetProgressOfCurrentSlide();
    },

    albumId(oldValue, newValue) {
      if (oldValue && newValue && oldValue !== newValue) {
        this.resetProgressOfCurrentSlide();
      }
    },

    percentOfProgress(value, oldValue) {
      this.isInProgress = value > oldValue;
      if (this.isInProgress) {
        this.currentSlideProgress = this.percentOfProgress;
      } else {
        this.currentSlideProgress = 0;
      }
    },
  },
});
</script>
